(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name tracking.service:TrackingModel
     *
     * @description
     *
     */
    angular
        .module('tracking')
        .service('TrackingModel', TrackingModel);

    function TrackingModel(rx) {
        var self = this;

        /**
         * Exposed Observables
         * @type {rx.Subject}
         */
        self.flightSearchCriteria = new rx.Subject();

        self.flightSearchResult = new rx.Subject();

        self.airportsList = new rx.ReplaySubject();

        self.aircraftTypes = new rx.ReplaySubject();

        self.crewBase = new rx.ReplaySubject();

        self.crewTypes = new rx.ReplaySubject();

        self.aircraftList = new rx.ReplaySubject();

        self.isRegNumberFilterActive =  new rx.ReplaySubject();

        self.regNumberFilterCriteria=  new rx.ReplaySubject();

        /**
         * Update Flight Search Criteria Stream
         * @param searchCriteria
         */
        self.setFlightSearchCriteria = function (searchCriteria) {
            self.flightSearchCriteria.onNext(searchCriteria || null);
        };

        /**
         * Update Airport List Stream
         * @param airports
         */
        self.setAirportsList = function (airports) {
            self.airportsList.onNext(airports || []);
        };

        /**
         * Update Aircraft Types Stream
         * @param aircraftTypes
         */
        self.setAircraftTypes = function (aircraftTypes) {
            self.aircraftTypes.onNext(aircraftTypes || []);
        };

        /**
         * Update Crewbase Stream
         * @param crewBase
         */
        self.setCrewBase = function (crewBase) {
            self.crewBase.onNext(crewBase || []);
        };

        /**
         * Update Aircraft List Stream
         * @param aircraftList
         */
        self.setAircraftList = function (aircraftList) {
            self.aircraftList.onNext(aircraftList || []);
        };

        /**
         * Update Flight Search Results Stream
         * @param flightSearchResult
         */
        self.setFlightSearchResult = function (flightSearchResult) {
            self.flightSearchResult.onNext(flightSearchResult);
        };

        /**
         * Update Flight Registration Number Filter Active Status Stream
         * @param flag
         */
        self.setRegNumberFilterActiveFlag = function (flag) {
            self.isRegNumberFilterActive.onNext(flag || false);
        };

        /**
         * Update Flight Registration number Filter Criteria Stream
         * @param filterCriteria
         */
        self.setRegNumberFilterCriteria = function (filterCriteria) {
            self.regNumberFilterCriteria.onNext(filterCriteria || []);
        };

        /**
         * Update Crew Types Stream
         * @param types
         */
        self.setCrewTypes = function (types) {
            self.crewTypes.onNext(types || []);
        };

    }
}());
